<app-soreach-dispo-filters [purchaseParams]="purchaseParams"></app-soreach-dispo-filters>
<app-soreach-dispo-grid></app-soreach-dispo-grid>